import { observer } from 'mobx-react-lite'
import { Icon } from 'shared/ui'
import { makeTextFieldClear, TextField } from 'shared/ui/TextField'
import { useTeamsContext } from 'pages/settings/pages/teams/context/teamsContext'
import styles from './styles.module.scss'

export const TeamsListSearch = observer(() => {
  const { search, setSearch } = useTeamsContext()

  return (
    <div className={styles.search}>
      <Icon icon='search' color='secondary' fontSize={18} padding={6} tertiary />
      <TextField
        className={styles.field}
        variant='integrated'
        InputProps={{
          placeholder: 'Search...',
        }}
        onChange={setSearch}
        value={search}
        rightActions={[
          makeTextFieldClear({
            isButton: true,
            isVisibleWithoutFocus: true,
          }),
        ]}
      />
    </div>
  )
})
